import {ComponentFieldModel} from './component-field-model';
import {ControlType} from '../enums';

/**
 * Defines a dropdown field type for editing the model for a component in the search ui.
 */
export class DropdownFieldModel extends ComponentFieldModel<string> {
  override controlType = ControlType.Dropdown;
}
